import React, { useState, useEffect } from 'react';
import './SimpleCaptcha.css';

const SimpleCaptcha = ({ onValidate, reset }) => {
  const [captchaQuestion, setCaptchaQuestion] = useState('');
  const [correctAnswer, setCorrectAnswer] = useState('');
  const [userAnswer, setUserAnswer] = useState('');
  const [isValid, setIsValid] = useState(null);

  const generateCaptcha = () => {
    // Generate simple math problems
    const operations = [
      { type: 'add', symbol: '+' },
      { type: 'subtract', symbol: '-' },
      { type: 'multiply', symbol: '×' }
    ];
    
    const operation = operations[Math.floor(Math.random() * operations.length)];
    let num1, num2, answer, question;

    switch (operation.type) {
      case 'add':
        num1 = Math.floor(Math.random() * 20) + 1;
        num2 = Math.floor(Math.random() * 20) + 1;
        answer = num1 + num2;
        question = `${num1} ${operation.symbol} ${num2} = ?`;
        break;
      case 'subtract':
        num1 = Math.floor(Math.random() * 30) + 10;
        num2 = Math.floor(Math.random() * num1) + 1;
        answer = num1 - num2;
        question = `${num1} ${operation.symbol} ${num2} = ?`;
        break;
      case 'multiply':
        num1 = Math.floor(Math.random() * 10) + 1;
        num2 = Math.floor(Math.random() * 10) + 1;
        answer = num1 * num2;
        question = `${num1} ${operation.symbol} ${num2} = ?`;
        break;
      default:
        num1 = 5;
        num2 = 3;
        answer = 8;
        question = '5 + 3 = ?';
    }

    setCaptchaQuestion(question);
    setCorrectAnswer(answer.toString());
    setUserAnswer('');
    setIsValid(null);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  useEffect(() => {
    if (reset) {
      generateCaptcha();
    }
  }, [reset]);

  const handleAnswerChange = (e) => {
    const value = e.target.value;
    setUserAnswer(value);
    
    if (value.trim() === correctAnswer) {
      setIsValid(true);
      onValidate(true);
    } else {
      setIsValid(false);
      onValidate(false);
    }
  };

  const handleRefresh = () => {
    generateCaptcha();
  };

  return (
    <div className="simple-captcha">
      <label>Security Verification *</label>
      <div className="captcha-container">
        <div className="captcha-question">
          <span className="math-question">{captchaQuestion}</span>
          <button 
            type="button" 
            className="captcha-refresh"
            onClick={handleRefresh}
            title="Generate new question"
          >
            🔄
          </button>
        </div>
        <input
          type="number"
          placeholder="Enter your answer"
          value={userAnswer}
          onChange={handleAnswerChange}
          className={`captcha-input ${isValid === true ? 'valid' : isValid === false ? 'invalid' : ''}`}
          required
        />
      </div>
      {isValid === false && userAnswer && (
        <div className="captcha-error">
          Incorrect answer. Please try again.
        </div>
      )}
      {isValid === true && (
        <div className="captcha-success">
          ✓ Verified
        </div>
      )}
    </div>
  );
};

export default SimpleCaptcha;